<template>
<div class="listContent">
    <div class="petui-container">
        <div class="petui-list">
            <div class="petui-item" v-for="(item,index) in listData" :key="item.pet_id">
                <router-link :to="{ name: 'detail', query: {id: item.pet_id} }">
                    <div class="petui-left petui-img" :style="'background-image:url(' + imgUrl +'/'+ item.pet_image + ')'">

                    </div>
                    <div class="petui-right">
                        <div class="petui-pet-info">
                            <div class="petui-info-top">
                                <div class="flex-start-name">
                                    <div class="petui-pet-name">
                                        {{item.pet_name}}
                                    </div>
                                    <div class="flex-center petui-pet-boy">
                                        <img v-if="item.pet_sex == 1" src="/img/man3x.png"></img>
                                        <img v-if="item.pet_sex == 2" src="/img/girl3x.png"></img>
                                    </div>
                                </div>
                                <div class="petui-city">{{item.city_name}}</div>
                            </div>
                            <div class="petui-pet-flex petui-label-content">
                                <!-- <div v-if="{{item.vaccine == 1}}" class="petui-vaccine petui-label">
                                    <div>#{{item.vaccine == 0 ? "未免疫" : "已免疫"}}</div>
                                </div> -->
                                <div v-if="item.is_sterilization" class="flex-center petui-label">
                                    #{{item.is_sterilization}}
                                </div>
                                <div v-if='item.is_repellent == 1' class="flex-center petui-label">
                                    {{item.is_repellent == 0 ? "#未驱虫" : "#已驱虫"}}
                                </div>
                                <div class="flex-center petui-label">
                                    #{{item.pet_age}}
                                </div>
                            </div>
                            <div class="petui-info-bottom">
                                <div class="petui-desc-content">
                                    <img src="/img/qm3x.png"></img>
                                    <div class="petui-desc">{{item.pet_desc}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </router-link>
            
            </div>
        </div>
    </div>
    <copy-right></copy-right>
</div>
</template>

<script>
import CopyRight from '@/components/CopyRight'

export default {
    name: 'List',
    components: {
        CopyRight
    },
    props: {
        listData: Array,
        imgUrl: String,
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,
        };
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/assets/style/petui.scss';
</style>
